<!-- <mat-dialog-content> -->
<div class="fz-dialog__close" mat-dialog-title>
  <button mat-icon-button (click)="handleClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="fz-dialog">
  <div class="fz-dialog__root">
    <div class="fz-dialog__head">
      <h2 class="fz-dialog__head__title mat-headline-small">
        Verify your Player Profile
      </h2>
      <p class="fz-dialog__head__subtitle mat-body-large">
        {{ message }}
      </p>
    </div>

    <div class="fz-dialog__content">
      <div class="resume" [class]="{ disabled: isDisabledEditInfoOptions }">
        <div class="resume__actions" *ngIf="!isDisabledEditInfoOptions">
          <a (click)="selectOption('edit-info')">
            Edit info and/or provide SSN
          </a>
        </div>
        <div class="resume__item">
          <label>Name:</label>
          <span>{{ userFullName }}</span>
        </div>
        <div class="resume__item">
          <label>DOB:</label>
          <span>{{ formatBirthday(birthday) }}</span>
        </div>
        <div class="resume__item">
          <label>Address:</label>
          <span>{{ address.fullAddress }}</span>
        </div>
      </div>

      <mat-radio-group
        aria-labelledby="Selct one of the following options"
        class="radio-button-group"
        [(ngModel)]="selectedOption"
      >
        @if (isEnableCreditCardOptions()) {
          <mat-radio-button
            class="radio-button-group__option"
            color="primary"
            [value]="'register-credit-card'"
            [disabled]="isDisabledCreditCardOptions"
          >
            <div class="radio-button-group__option__root">
              <div class="radio-button-group__option__content">
                <span class="radio-button-group__option__content__title"
                  >Register a Credit Card</span
                >
                <span
                  class="radio-button-group__option__content__subtitle mat-body-small"
                  >Your Credit Card will <b>NOT</b> be Charged.</span
                >
              </div>
              <div class="radio-button-group__option__end_adornment">
                <mat-icon>credit_card</mat-icon>
              </div>
            </div>
          </mat-radio-button>
        }
        <mat-radio-button
          class="radio-button-group__option"
          color="primary"
          value="upload-id-picture"
          [disabled]="isDisabledUploadOptions"
        >
          <div class="radio-button-group__option__root">
            <div class="radio-button-group__option__content">
              <span class="radio-button-group__option__content__title">
                Upload ID Picture
              </span>
              <span
                class="radio-button-group__option__content__subtitle mat-body-small"
              >
                It might take up to 48 hours (JPG, PNG, up to 20MB)
              </span>
            </div>
            <div class="radio-button-group__option__end_adornment">
              <mat-icon>photo</mat-icon>
            </div>
          </div>
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="fz-dialog__actions">
      <button
        mat-flat-button
        color="primary"
        class="full-width"
        [disabled]="isDisabledCreditCardOptions && isDisabledUploadOptions"
        (click)="handleSelection()"
      >
        Complete Verification
      </button>
    </div>
  </div>
</div>
<!-- </mat-dialog-content> -->
<!-- <mat-dialog-actions> -->

<!-- </mat-dialog-actions> -->
